<template>
  <div
    class="z-50 flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
  >
    <div
      class="box-border md:w-[400px] w-[90%] bg-white p-6 rounded-lg relative !z-999"
    >
      <button
        @click="closeForm"
        class="absolute top-0 right-0 -mt-4 -mr-4 p-2 bg-gray-200 rounded-full hover:bg-gray-300 focus:outline-none"
      >
        <svg
          class="w-6 h-6 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>
      <div>
        <h3 class="text-center text-black text-[24px] pb-4 font-medium">
          Download Brochure
        </h3>
      </div>
      <form @submit.prevent="submitForm">
        <div class="flex flex-col gap-4 pt-3">
          <div
            class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 rounded-md h-8 focus-within:border-blue-500"
          >
            <input
              type="text"
              name="name"
              id="name"
              autocomplete="off"
              class="form-control widget_input w-full border-none focus:outline-none focus:ring-0"
              maxlength="255"
              minlength="1"
              placeholder="Name *"
              required
              v-model="name"
              v-on:input="validateInput"
            />
          </div>
          <div
            class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 rounded-md h-8 focus-within:border-blue-500"
          >
            <input
              class="w-full border-none focus:outline-none focus:ring-0"
              type="email"
              name="email"
              id="email"
              autocomplete="off"
              maxlength="50"
              placeholder="Email *"
              required
              v-model="email"
            />
          </div>
          <div
            class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 rounded-md focus-within:border-blue-500 relative"
          >
            <div class="flex">
              <select
                v-model="selectedCountryCode"
                @change="handleChange"
                class="form-control widget_input w-20 h-8 bg-gray-200 text-center"
              >
                <option
                  v-for="country in countryCodes"
                  :key="country.code"
                  :value="country.code"
                >
                  {{
                    selectedCountryCode === country.code
                      ? country.code
                      : `${country.name} (${country.code})`
                  }}
                </option>
              </select>
              <input
                type="tel"
                name="mobile"
                id="Mobile"
                autocomplete="off"
                maxlength="10"
                class="form-control widget_input w-full border-none focus:outline-none focus:ring-0 pl-2"
                pattern="[0-9]*"
                placeholder="Mobile *"
                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                v-model="phoneNumber"
                required
              />
              <!-- <p
                type="button"
                class="absolute right-5 pt-2 text-xs"
                :class="{
                  'text-[#0A2767]': !otpCooldown,
                  'text-green-700': otpCooldown,
                  'cursor-pointer': !otpCooldown && phoneNumber.length === 10,
                  'opacity-50 cursor-not-allowed':
                    otpCooldown || phoneNumber.length !== 10,
                }"
                @click="getOtp"
                :disabled="otpCooldown || phoneNumber.length !== 10"
              >
                {{ otpCooldown ? "OTP Sent" : "Get OTP" }}
              </p> -->
            </div>
          </div>
          <!-- <div
            class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 rounded-md h-8 focus-within:border-blue-500"
          >
            <input
              type="tel"
              name="otp"
              id="otp"
              autocomplete="off"
              maxlength="6"
              class="form-control widget_input w-full border-none focus:outline-none focus:ring-0"
              pattern="[0-9]*"
              placeholder="OTP *"
              v-model="enteredOtp"
              @input="sanitizeInput"
              required
            />
          </div> -->
          <!-- <div
            v-if="submissionStatus === 'otpError'"
            class="text-red-500 text-xs text-left pl-0 mt-1"
          >
            {{ otpErrorMessage }}
          </div> -->

          <div
            class="box-border text-[14px] leading-normal text-[#333] text-center p-1"
          >
            <button
              type="submit"
              class="form-control widget_input w-full bg-[#001C54] hover:bg-[#F8C300] font-bold text-[16px] text-white p-2 rounded-md"
            >
              Download Brochure
            </button>
          </div>
        </div>
      </form>
      <div>
        <span
          v-if="submissionStatus === 'error'"
          class="text-red-500 text-xs"
          >{{ errorMessage }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import countryCodeMixins from "@/mixins/countryCodeMixins";
export default {
  name: "BrochureElectiveView",
  mixins: [countryCodeMixins],
  props: ["url", "elective", "program", "elective_data"],
  data() {
    return {
      mobileNumber: "",
      errorMessage: "",
      otpErrorMessage: "",
      submissionStatus: "",
      errorStatus: false,
      name: "",
      email: "",
      selectedProgram: "",
      selectedElective: "",
      selectedState: "",
      selectedCity: "",
      phoneNumber: "",
      selectedCountryCode: "+91",
      enteredOtp: "",
      otpCooldown: false,
      otpSent: false,
    };
  },
  mounted() {
    this.fetchProgramsAndElectives();
  },
  methods: {
    async getOtp() {
      if (this.phoneNumber.length !== 10 || this.otpCooldown) {
        return;
      }
      try {
        const json_data = {
          to: `${this.selectedCountryCode}${this.phoneNumber}`,
        };
        const response = await axios.post(
          `${process.env.VUE_APP_API}/enquires/otp/`,
          json_data
        );
        console.log(response);
        this.otpSent = true;
        this.otpCooldown = true;
        this.startOtpCooldown();
      } catch (error) {
        console.error("Error getting OTP:", error);
      }
    },
    startOtpCooldown() {
      setTimeout(() => {
        this.otpSent = false;
        this.otpCooldown = false;
      }, 30000);
    },
    closeForm() {
      this.$emit("close-button");
      this.resetForm();
    },
    async submitForm(el) {
      this.errorStatus = false;
      this.submissionStatus = "";

      const formData = {
        name: this.name,
        email: this.email,
        phone: `${this.selectedCountryCode}${this.phoneNumber}`,
        university: "jain",
        state: "",
        city: "",
        utmCampaign: this.$route.query.utm_campaign || "",
        utmSource: this.$route.query.utm_source || "",
        utmMedium: this.$route.query.utm_medium || "",
        utmPlacement: this.$route.query.utm_placement || "",
        utmAdgroupId: this.$route.query.utm_adgroupid || "",
        utmCreativeId: this.$route.query.utm_creativeid || "",
        utmDevice: this.$route.query.utm_device || "",
        utmNetwork: this.$route.query.utm_network || "",
        utmCampaignId: this.$route.query.utm_campaignid || "",
        utmMatchType: this.$route.query.utm_matchype || "",
        utmKeyword: this.$route.query.utm_keyword || "",
        utmChannel: "Elective Brochure" || "",
        utmURL: window.location.href || "",
      };
      if (this.mergedProgramAndElectiveData) {
        formData.programName = this.mergedProgramAndElectiveData.program_slug;
        formData.programElective =
          this.mergedProgramAndElectiveData.elective_slug;
      }
      var thatSelect = this;

      const response = await axios
        .post(`${process.env.VUE_APP_LEADAPI}/lead/`, formData)
        .then((response) => {
          if (thatSelect.url) {
            const responseData = response.data;
            if (responseData.lead.success === true) {
              const newTab = window.open(thatSelect.url, "_blank");
              if (newTab) {
                const a = newTab.document.createElement("a");
                a.href = thatSelect.url;
                a.download = `${this.elective}-brochure.pdf`;
                newTab.document.body.appendChild(a);
                a.click();
                newTab.document.body.removeChild(a);
              }

              // Push data to the dataLayer
              dataLayer.push({
                "event": "Brochure Form Filled",
                "Attribute": {
                  "Elective Title": this.elective_data.name,
                  "Elective ID": this.elective_data.order,
                  "Program": this.elective_data.program.name,
                  "Program ID": this.elective_data.program.id,
                  "Domain": this.elective_data.program.category.name,
                  "Domain ID": this.elective_data.program.category.id,
                  "Name": this.name,
                  "Email": this.email,
                  "Phone": this.phoneNumber,
                },
              });

              // Trigger the conversion code
              if (typeof gtag === "function") {
                gtag("event", "conversion", {
                  send_to: "AW-413149258/X8diCMKa74oYEMrQgMUB",
                });
              } else {
                console.warn("gtag function is not defined.");
              }

              setTimeout(() => {
                thatSelect.selectedCountryCode = "+91";
                thatSelect.mobileNumber = "";
                thatSelect.closeForm();
              }, 2000);
            } else {
              if (
                responseData.status === 400 &&
                responseData.message === "failure" &&
                responseData.alert === "Invalid OTP"
              ) {
                this.submissionStatus = "otpError";
                this.otpErrorMessage = responseData.alert;
              } else if (
                responseData.status === 400 &&
                responseData.message === "failure" &&
                responseData.alert === "OTP Expired"
              ) {
                this.submissionStatus = "otpError";
                this.otpErrorMessage = responseData.alert;
              } else {
                this.submissionStatus = "error";
                this.errorMessage =
                  responseData.data.data.error_list.common ||
                  responseData.data.message;
              }
            }
          } else {
            this.submissionStatus = "error";
            this.errorMessage = "Pdf not available";
          }
        });
    },

    async fetchProgramsAndElectives() {
      try {
        // Call the API to get programs and electives
        const response = await axios.get(
          `${process.env.VUE_APP_ELECTIVE}/?university_slug=jain-online-website`
        );

        // Check if data is available
        if (
          response.data &&
          response.data.data &&
          response.data.data.length > 0
        ) {
          const apiPrograms = response.data.data[0].programs;

          // Check if props data exists (program and elective)
          if (this.$props.program && this.$props.elective) {
            // Find matching program using program_page_short_slug from props
            const matchingProgram = apiPrograms.find(
              (apiProgram) =>
                apiProgram.program_page_short_slug === this.$props.program
            );

            if (matchingProgram) {
              // If matching program is found, match electives using elective_page_slug from props
              const matchingElective = matchingProgram.program_elective.find(
                (apiElective) =>
                  apiElective.elective_page_slug === this.$props.elective
              );

              if (matchingElective) {
                // Merge the matching program and elective data
                const mergedData = {
                  program_name: matchingProgram.program_name,
                  program_slug: matchingProgram.program_slug,
                  program_page_slug: matchingProgram.program_page_slug,
                  program_page_short_slug:
                    matchingProgram.program_page_short_slug,
                  elective_name: matchingElective.elective_name,
                  elective_slug: matchingElective.elective_slug,
                  elective_page_slug: matchingElective.elective_page_slug,
                  elective_page_program_short_slug:
                    matchingElective.elective_page_program_short_slug,
                  _id: matchingElective._id,
                };

                // Store the merged data in the component's state
                this.mergedProgramAndElectiveData = mergedData;
              } else {
                this.errorMessage = "No matching elective found";
              }
            } else {
              this.errorMessage = "No matching program found";
            }
          }
        } else {
          this.errorMessage = "No programs and electives found";
        }
      } catch (error) {
        console.error("Error fetching programs and electives:", error);
        this.errorMessage = "Failed to load programs and electives";
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.submissionStatus = "";
      this.name = "";
      this.email = "";
      this.selectedProgram = "";
      this.selectedElective = "";
      this.selectedState = "";
      this.selectedCity = "";
      this.phoneNumber = "";
      this.enteredOtp = "";
      this.otpSent = false;
      this.selectedCountryCode = "+91";
    },
    validateInput(event) {
      const regex = /^[A-Za-z\s]*$/;
      if (!regex.test(event.target.value)) {
        event.target.value = event.target.value.replace(/[^A-Za-z\s]/g, "");
      }
      this.name = event.target.value;
    },
  },
};
</script>
<style></style>
